// Utils & misc
import cn from '../../../utils/cn';

// Components
import Picto from '../Picto/Picto';

// Style
import style from './Tag.module.css';

/**
 * Tag component - Simple tag with theme support
 * @param {object} params
 * @param {'primary' | 'neutral' | 'success' | 'alert' | 'yellow' | 'orange' | 'green' | 'blue'} [params.theme='primary'] - Theme of the tag
 * @param {React.ReactNode} params.children - Content of the tag
 * @param {string} [params.className] - Additional CSS classes
 * @param {() => void} [params.onRemove] - Optional remove handler; shows a close icon when set
 * @returns {JSX.Element} Tag component
 */
function Tag({
  theme = 'primary',
  children,
  className,
  onRemove,
}) {
  return (
    <div
      className={cn([style.tag, style[theme], className])}
    >
      <span className={style.label}>{children}</span>
      {onRemove ? (
        <button
          type="button"
          className={style['remove-button']}
          onClick={(event) => {
            event.stopPropagation();
            onRemove();
          }}
          aria-label="Remove"
        >
          <Picto icon="close-md" className={style['remove-icon']} />
        </button>
      ) : null}
    </div>
  );
}

export default Tag;
